export class UpdateRoleName {
	public name: string;
}
